var ConnectSocialBarComponent = /** @class */ (function () {
    function ConnectSocialBarComponent() {
    }
    Object.defineProperty(ConnectSocialBarComponent.prototype, "strippedWebLink", {
        get: function () {
            // Strip the extra characters like https out
            //
            if (!this._strippedWebLink) {
                this._strippedWebLink = this.web ? this.web.replace(/^\/\/|^.*?:(\/\/)?/, '') : '';
            }
            return this._strippedWebLink;
        },
        enumerable: true,
        configurable: true
    });
    return ConnectSocialBarComponent;
}());
export { ConnectSocialBarComponent };
